import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import NosePiercingImage from '../../Assets/Piercing Services/nose piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function NosePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Nose Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Nose Piercing Dubai, UAE for a classic and stylish look, performed by trained piercers using hygienic techniques and quality products."
            />  
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Nose Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Nose Piercing 150 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={NosePiercingImage} alt="Nose Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Nose Piercing</h3>

          <p>
            Enhance your beauty with our professional nose piercing services in the UAE, available at an affordable price of 150 AED. Nose piercing is a timeless and elegant choice that has remained popular across cultures and fashion trends, offering a subtle yet impactful way to express your personal style. Whether you prefer a minimal stud or a stylish hoop, our expert specialists ensure precise placement that complements your facial features and enhances your overall appearance.
          </p>

          <p>
            At our piercing studio, we prioritize safety, hygiene, and comfort above all else. Our certified professionals use sterile, single-use, high-quality equipment to perform each nose piercing with the utmost care and precision. We follow strict hygiene protocols to ensure a clean and infection-free environment, giving you complete peace of mind throughout the process. Our goal is to provide a smooth, quick, and pain-minimized experience, making nose piercing suitable for both first-time clients and those looking to upgrade their look.
          </p>

          <p>
            Nose piercing is one of the most versatile and widely loved piercing styles, perfect for anyone who wants to add a touch of elegance and individuality to their appearance. It suits all age groups and can be styled in multiple ways to match your personality, whether you prefer a classic, modern, or bold look. Our specialists take the time to understand your preferences and guide you in choosing the ideal placement and jewelry to achieve the best results.
          </p>

          <p>
            The procedure itself is quick and typically completed within minutes, ensuring minimal discomfort and maximum convenience. We use advanced techniques designed to reduce pain and promote faster healing, allowing you to enjoy your new piercing without unnecessary stress. Our team also provides high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Aftercare is an essential part of maintaining your nose piercing, and we provide detailed instructions to help you care for it properly. Our specialists guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper care, your nose piercing will heal smoothly and remain a beautiful addition to your style.
          </p>

          <p>
            Our nose piercing services in the UAE combine affordability with premium quality, offering exceptional value without compromising on safety or professionalism. We maintain transparent pricing with no hidden charges, ensuring you receive top-quality service at a competitive rate. Booking your appointment is easy and convenient, allowing you to choose a time that fits your schedule. We strive to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted nose piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, sterile procedures, and a customer-focused approach, we ensure that every client leaves satisfied and confident. Book your nose piercing appointment today and add a timeless touch of elegance to your look with expert care and precision.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Nose Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NosePiercing;